<template>
  <div class="kefu">
    <div class="kefu_box">
      <!-- <div class="kefu_iframe"> -->
      <iframe id="kefIframe"
              :src="qiyuUrl">
      </iframe>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { getSessionStorage } from '../../utils/stage'
export default {
  data() {
    return {
      qiyuUrl: '',
    }
  },
  mounted() {
    if (JSON.parse(getSessionStorage('accountStorage')).web_config.jp == 1) {
      this.qiyuUrl =
        'https://shfthwcs.servehub.aiconn.com/client?k=0156c4ac7379903ddc87209e852bab04&wp=1&robotShuntSwitch=0&gid=482415559&language=ja&templateId=6637118'
      return
    }
    if (JSON.parse(getSessionStorage('accountStorage')).lang == 'ko-kr') {
      this.qiyuUrl =
        'https://shfthwcs.servehub.aiconn.com/client?k=0156c4ac7379903ddc87209e852bab04&wp=1&robotShuntSwitch=0&gid=482401076&language=ko&templateId=6637118'
      return
    }
    ;(function (w, d, n, a, j) {
      w[n] =
        w[n] ||
        function () {
          ;(w[n].a = w[n].a || []).push(arguments)
        }
      j = d.createElement('script')
      j.async = false
      j.src =
        'https://shfthwcs.servehub.aiconn.com/script/0156c4ac7379903ddc87209e852bab04.js?'
      d.body.appendChild(j)
    })(window, document, 'ysf')
    setTimeout(() => {
      this.qiyu()
    }, 3000)
  },
  created() {},
  methods: {
    qiyu() {
      const account = JSON.parse(getSessionStorage('accountStorage'))
      ysf('config', {
        uid: account.open_id,
        hidden: 1,
        wp: 1,
        robotShuntSwitch: 0,
        shuntId: 0,
        language: JSON.parse(getSessionStorage('accountStorage')).lang,
        data: JSON.stringify([
          // { key: 'mobile_phone', value: account.phone },
          // { key: 'app_name', label: '游戏项目', value: account.app_name },
          // { key: 'username', label: '通行证账号', value: account.username },
          // { key: 'channel', label: '渠道', value: account.channel },
          { key: 'role_name', label: '角色名', value: account.role_name },
          { key: 'email', label: '邮箱', value: account.email },
          { key: 'uid', label: '玩家UID', value: account.uid },
          { key: 'server', label: '区服', value: account.server },
          { key: 'level', label: '等级', value: account.level },
        ]),
      })
      var isSdkReady = false
      ysf('onready', function () {
        isSdkReady = true
      })
      if (isSdkReady) {
        console.log(ysf('url'))
        this.qiyuUrl = ysf('url')
      } else {
        alert('sdk尚未加载成功，请稍后再试')
      }
    },
  },
}
</script>

<style lang="less">
.user_content .content-box {
}
// .kefu {
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   top: 100px;
//   left: 0;
// }
.kefu_box {
  width: 100%;
  height: calc(100vh - 90px);
  #kefIframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
